<template>
<div>

  <!-- View third party modal template -->
  <b-modal
     ref="view-tp"
     hide-footer
     @hide="hideTPModal"
     size="lg"
  >

    <template #modal-header="{ close }">
      <div class="text-center" style="width: 100%;">
        <span @click="hideTPModal" class="btn btn-secondary cursor-pointer float-right">
          <font-awesome-icon icon="times"/>
        </span>
        <h4 qid="update-tp-title" class="mb-2 ml-4 pl-4">
          {{ object.name }}
        </h4>
      </div>
    </template>

    <div class="form-container mt-3">
      <div class="card-modern pl-2 pr-2">
        <div class="mb-2">
          <span v-if="object.users && object.users.length" class="mr-2" qid="p-owners-list">
            {{ $t('table.owners') }}:
          </span>
          <span class="mr-1" v-for="user in object.users">
            <Avatar :object="user" size="xs"></Avatar>
          </span>
          <span v-if="object.category" class="mr-2" qid="p-owners-list">
            {{ $t('maintenance.policies.table.category') }}:
          </span>
          <span class="mr-1 text-normal" v-if="object.category">
            <font-awesome-icon icon="shapes"/>
            {{ $t('maintenance.policies.category.' + $options.filters.slugify(object.category)) }}
          </span>
          <span v-if="object.organization" class="mr-2" qid="p-owners-list">
            {{ $t('administration.users.create.organization_label') }}:
          </span>
          <span class="mr-1 text-normal" v-if="object.organization">
            <font-awesome-icon icon="sitemap"/>
            {{ object.organization.name }}
          </span>
          <span v-if="object.tags_translated && object.tags_translated.length" class="mr-2 ml-2">
            {{ $t('table.tags') }}:
          </span>
          <span v-if="object.tags_translated && object.tags_translated.length" qid="activity-tags-list">
            <span class="badge" v-for="tag in object.tags_translated" :title="tag.name_translated">
              <font-awesome-icon icon="tag"/>
              {{ tag.name_translated | truncate(35) }}
            </span>
          </span>
        </div>
      </div>
    </div>

    <div class="form-container">
      <h5>{{ $t('processes.create.description_label') }}</h5>
      <div class="card-modern pl-2 pr-2">
        <div v-if="object.description && object.description.length > 300">
          <p v-if="showFullDescription" class="text-formatted">{{ object.description }}</p>
          <p v-if="!showFullDescription" class="text-formatted">{{ object.description | truncate(300) }}</p>
          <div class="text-center mt-3" @click="showFullDescription=!showFullDescription">
            <span class="cursor-pointer" v-if="!showFullDescription">
              <span class="mr-2">
                {{ $t('system.view_more') }}
              </span>
              <font-awesome-icon icon="chevron-down"/>
            </span>
            <span class="cursor-pointer" v-if="showFullDescription">
              <span class="mr-2">
                {{ $t('object.view_less') }}
              </span>
              <font-awesome-icon icon="chevron-up"/>
            </span>
          </div>
        </div>
        <p v-if="object.description && object.description.length <= 300"
           class="text-formatted"
        >{{ object.description }}</p>
        <p v-if="!object.description" class="text-muted">
          {{ $t('system.missing_input') }}
        </p>
      </div>
    </div>


    <div class="form-container mt-3">
      <h5 class="mb-2" qid="measure-table-title">
        {{ $t('maintenance.third_parties.documents.title') }}
      </h5>
      <table class="table table-responsive-md table-list-secondary">
        <thead>
        <tr>
          <th scope="col">
            {{ $t('activities.measures.table.name') }}
          </th>
          <th scope="col">
            {{ $t('maintenance.third_parties.documents.category') }}
          </th>
          <th width="140"></th>
        </tr>
        </thead>
        <tbody>
          <tr v-for="document in documentTableItems" v-if="document.latest_publish_version.status && document.latest_publish_version.status == 'published'">
            <td>
              <span v-if="document && document.latest_publish_version && document.latest_publish_version.name">
                {{ document.latest_publish_version.name }}
              </span>
            </td>
            <td>
              <span v-if="document && document.latest_publish_version && document.latest_publish_version.category" class="text-normal">
                <font-awesome-icon icon="shapes"/>
                {{ document.latest_publish_version.category }}
              </span>
            </td>
            <td class="text-right">
              <button
                  @click="showChangelogModal(document)"
                  class="btn btn-view"
              >
                <font-awesome-icon icon="history"/>
              </button>
              <button
                  @click="openDocument(document.latest_publish_version)"
                  class="btn btn-view"
                  v-if="document && document.latest_publish_version"
                  :disabled="document.latest_publish_version && (!document.latest_publish_version.master || document.latest_publish_version.status != 'published')"
              >
                <font-awesome-icon :icon="['fab', 'readme']"/>
              </button>
            </td>
          </tr>
          <tr v-if="!measureLoading && !publishedItems" qid="no-results-row-rr" class="text-center">
            <td colspan="10">
              <h5 class="mt-3">
                {{ $t('system.no_results') }}
              </h5>
            </td>
          </tr>
          <tr v-if="measureLoading" qid="no-results-row-rr" class="text-center">
            <td colspan="10">
              <div class="mt-2 mb-4">
                <div class="swing-container">
                  <div class="swing">
                    <div class="swing-l"></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div class="swing-r"></div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>


    <div class="text-right">
      <b-button class="mt-3"
                variant="secondary"
                @click="hideTPModal"
                qid="create-rr-cancel-button"
      >
        {{ $t('system.close') }}
      </b-button>
    </div>

  </b-modal>



  <!-- Changelog modal template -->
  <b-modal ref="change-log" hide-footer size="lg">
    <div class="d-block text-center">
      <h4 qid="delete-s-title">
        {{ $t('maintenance.policies.documents.changelog_modal_title') }}
      </h4>
    </div>

    <div class="form-container">
      <div v-for="version in versions" class="mb-4">
        <div class="mb-2">
          <span class="mr-2" qid="view-p-modified-date" style="font-size:18px;">
            {{ version.updated_at | formatDate }}
          </span>
          <span v-if="version.updated_by && version.updated_by.name">{{ $t('system.by') }}</span>
          <Avatar v-if="version.updated_by" :object="version.updated_by" size="xs" class="ml-3 mr-2"></Avatar>
          <span v-if="version.updated_by" qid="view-p-modified-by">
            {{ version.updated_by.name }}
          </span>
        </div>
        <div class="card-modern pl-2 pr-2" v-if="version">
          <div v-if="version.change_log && version.change_log.length > 300">
            <p v-if="showFullChangelog" class="text-formatted">{{ version.change_log }}</p>
            <p v-if="!showFullChangelog" class="text-formatted">{{ version.change_log | truncate(300) }}</p>
            <div class="text-center mt-3" @click="showFullChangelog=!showFullChangelog">
              <span class="cursor-pointer" v-if="!showFullChangelog">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullChangelog">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="version.change_log && version.change_log.length <= 300"
             class="text-formatted"
          >{{ version.change_log }}</p>
          <p v-if="!version.change_log" class="text-muted">
            {{ $t('system.missing_input') }}
          </p>
        </div>
      </div>

    </div>

    <div class="text-right">
      <b-button class="mt-3"
                variant="secondary"
                @click="hideChangelogModal"
                qid="create-rr-cancel-button"
      >
        {{ $t('system.close') }}
      </b-button>
    </div>
  </b-modal>

</div>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import Avatar from '@/components/Avatar.vue';


  export default {
    name: 'PolicyViewModal',
    data: function() {
      return {
        error: '',
        showInput: false,
        inputLink: '',
        inputLinkName: '',
        loadingItems: false,
        showArticleDescription: false,
        secondaryDO: [],
        selectedFileObject: {},
        selectedFileIndex: '',
        selectedLinkObject: {},
        selectedLinkIndex: '',
        showFullDescription: false,
        showFullChangelog: false,
        loadingItems: false,
        selectedDocument: [],
        selectedTableItem: [],
        viewRRModal: false,
        editRRModal: false,
        selectedDocumentSort: '',
        selectedDocumentDirection: '',
        acValidationShow: false,
        documentTableItems: [],
        documentSingleTableItems: [],
        measureLoading: true,
        measureItems: [],
        updateValidationList: false,
        itemToDelete: {},
        itemObject: {},
        reCertificationOptions: [],
        provisioningOptions: [],
        selectedRC: [],
        selectedP: [],
        validationOptions: [],
        validation: undefined,
        disabledValidationOptions: [],
        showRRDescription: false,
        buttonDisabled: false,
        versionsLoading: false,
        versions: [],
        publishedItems: 0
      }
    },
    props: {
      object: {
        type: [Object,Array]
      },
      showModal: {
        type: Boolean
      },
    },
    components: {
      Avatar
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getMedia() {
        return this.object.media
      }
    },
    watch: {
      // Watch when prop changes
      showModal: function (value) {
        if (value) {
          this.showTPModal()
        }
      }
    },
    methods: {
      showTPModal() {
        let self = this;
        this.measureLoading = true;
        this.publishedItems = 0;
        this.documentTableItems = []
        this.loadDocuments()
        this.$refs['view-tp'].show()
      },
      hideTPModal() {
        this.error = ''
        this.showFullDescription = false;
        this.$emit('closeViewModal');
        this.$refs['view-tp'].hide()
      },
      showChangelogModal(object) {
        this.selectedDocument = object
        this.loadVersions()
        this.$refs['change-log'].show()
      },
      hideChangelogModal() {
        this.selectedDocument = {}
        this.showFullChangelog = false;
        this.$refs['change-log'].hide()
      },
      loadVersions() {
        let self = this;

        piincHttp.get('policies/' + this.object.slug + '/documents', { params:
          {
            policy_document_id: this.selectedDocument.id,
            per_page: 100,
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.versionsLoading = false;
          self.versions = response.data.items;
        }, function() {});
      },
      openDocument(object) {
        if (object.master) {

          if (object.master.who_am_i == 'App\\Maintenance\\Links\\Models\\Link') {
            window.open(object.master.url);
          }

          if (object.master.who_am_i == 'App\\Maintenance\\Document\\Models\\Document') {
            piincHttp.get('documents/' + object.master.id + '/download?client='+this.getClient.slug, {responseType: 'blob'}).then(function(response) {
              const blobURL = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}));
              window.open(blobURL);
            }, function() {});
          }
        }
      },
      loadDocuments() {
        let self = this;
        piincHttp.get('policies/' + this.object.slug + '/documents', { params:
          {
            per_page: 10,
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.measureLoading = false;
          self.documentTableItems = response.data.items;
          _.forEach(self.documentTableItems, function (item) {
            if (item.latest_publish_version.status == 'published') {
              self.publishedItems += 1
            }
          })
        }, function() {});
      },
    },
    created () {

    }
  }
</script>
